<template>
  <v-row>
    <v-col>
      <SurgeryTherapyList />
    </v-col>
  </v-row>
</template>

<script>
  import SurgeryTherapyList from "@/components/config/template/surgery-therapy/list.vue";

  export default {
    name: "TemplateSurgeryTerapyConfig",
    components: {
      SurgeryTherapyList,
    },
  };
</script>

<style lang="scss" scoped></style>
